import { createNamespacedHelpers } from 'vuex';
import { DefineActions, DefineGetters, DefineMutations } from 'vuex-type-helper';
import { ThisWaybill, Getters, Mutations, Actions } from '@/models/Waybill.model';

// Inital state
const state: ThisWaybill = {
  waybill: {
    id: 0,  
    customerId: 0,
    customer: '',
    orderId: 0,    
    externalOrderNumber: '',
    externalCreatedAt: '',
    waybillCreatedAt: '',
    waybillNumber: '',
    totalItems: 0,
    totalCost: '',
    weight: '',
    originalAddress: {
      contactPerson: '',
      phoneHome: '',
      phoneWork: '',
      phoneCell: '',
      email: '',
      companyName: '',
      address1: '',
      address2: '',
      address3: '',
      addressSuburb: '',
      addressProvince: '',
      addressCountry: '',
      postCode: '',
      boxCode: '',
    },
    toAddress: {
      contactPerson: '',
      phoneHome: '',
      phoneWork: '',
      phoneCell: '',
      email: '',
      companyName: '',
      address1: '',
      address2: '',
      address3: '',
      addressSuburb: '',
      addressProvince: '',
      addressCountry: '',
      postCode: '',
      boxCode: '',
    },
    addressValidationStatus: '',
    cellValidationStatus: '',
    courierSuggestionAccepted: false,
    waybillStatusId: 0,
    waybillStatus: '',
    courierId: 0,  
    courier: '',
    storeId: 0,
    storeName: '',
    pickupLocationId: 0,
    pickupLocation: '',
    externalShippingService: '',
    externalShippingPrice: '',
    shippingServiceId: 0,
    shippingService: '',
    specialInstructions: '',
    collectionDate: '',
    collectionTime: '',
    manifestId: 0,
    packages: [],
  },
};

// Gets the values of our state usually called from components
const getters: DefineGetters<Getters, ThisWaybill> = {
  waybill: (state) => state.waybill,

  collectionTimes: (state) => {
    return [
      'Morning',
      'Afternoon',
    ];
  },
};

// Sets values or changes to state. Must be called via an action.
const mutations: DefineMutations<Mutations, ThisWaybill> = {
  resetWaybill() {
    state.waybill = {
      id: 0,  
      customerId: 0,
      customer: '',
      orderId: 0,    
      externalOrderNumber: '',
      externalCreatedAt: '',
      waybillCreatedAt: '',
      waybillNumber: '',
      totalItems: 0,
      totalCost: '',
      weight: '',
      originalAddress: {
        contactPerson: '',
        phoneHome: '',
        phoneWork: '',
        phoneCell: '',
        email: '',
        companyName: '',
        address1: '',
        address2: '',
        address3: '',
        addressSuburb: '',
        addressProvince: '',
        addressCountry: '',
        postCode: '',
        boxCode: '',
      },
      toAddress: {
        contactPerson: '',
        phoneHome: '',
        phoneWork: '',
        phoneCell: '',
        email: '',
        companyName: '',
        address1: '',
        address2: '',
        address3: '',
        addressSuburb: '',
        addressProvince: '',
        addressCountry: '',
        postCode: '',
        boxCode: '',
      },
      addressValidationStatus: '',
      cellValidationStatus: '',
      courierSuggestionAccepted: false,
      waybillStatusId: 0,
      waybillStatus: '',
      courierId: 0,  
      courier: '',
      storeId: 0,
      storeName: '',
      pickupLocationId: 0,
      pickupLocation: '',
      externalShippingService: '',
      externalShippingPrice: '',
      shippingServiceId: 0,
      shippingService: '',
      specialInstructions: '',
      collectionDate: '',
      collectionTime: '',
      manifestId: 0,
      packages: [],
    };
  },

  setWaybill(state, { waybill }) {
    state.waybill = waybill;
  },
};

// Async functions that will contain the logic / service calls and commit mutations to state
const actions: DefineActions<Actions, ThisWaybill, Mutations, Getters> = {
  resetWaybill({ commit }, payload) {
    commit('resetWaybill', payload);
  },

  setWaybill({ commit }, payload) {
    commit('setWaybill', payload);
  },
};

export const {
  mapState,
  mapGetters,
  mapMutations,
  mapActions,
} = createNamespacedHelpers<ThisWaybill, Getters, Mutations, Actions>('WaybillModule');

export const WaybillModule = {
  namespaced: true,
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions,
};
